import { OF } from '../../util/network';
import { JBaseApi } from '../base';
import { ApiWrapper } from '../../types/utils';

export class JAccessibilityApi extends JBaseApi {
    public async GetStatus(): Promise<ApiWrapper<string>> {
        return this.network.post({
            o: 'accessibility',
            f: 'getStatus',
        } as OF);
    }
}
